module.exports = __webpack_public_path__ + "img/invalid-link.fc352364.png";